module.exports = __webpack_public_path__ + "img/12.53556e38.png";